import { ng } from "@common/ngds";
import { Drawer, PathBuilder } from "@common/components/Rendering";
import { ArrowId, stirrup_style } from "../ViewportStyles";
import { Extent } from "./drawGeomCrossSection";
import { findSectionInProject } from "./shared";

export const shouldDrawStirrup = (projectData: ng.frontend.column.Project) => {
    const { sec } = findSectionInProject(projectData);
    switch (sec?.materialCategory) {
        // only draw stirrup when the material is concrete
        case ng.sections.MaterialCategory.MATERIAL_CATEGORY_CONCRETE:
            return true;
        default:
            return false;
    }
}

export const drawStirrup = (drawer: Drawer<ArrowId>, data: ng.project.Data | null, geom: Extent) => {
    const inputJson = data?.input;
    const structureJson = inputJson?.structures[0] ?? null;
    const element = structureJson?.elements?.[0] ?? null;
    const beam = element?.getBeam() ?? null;
    const links = beam?.getConcrete()?.links ?? null;
    const firstLinkGroup = links?.linkGrps?.[0] ?? null;
    const stirrupDiameter = firstLinkGroup?.diameter ?? 0.0;

    const first_element = data?.input?.structures?.[0]?.elements[0];
    const first_segment = first_element?.getBeam()?.segments?.[0];
    const secGuid = first_segment?.layer?.start?.secGuid;
    const sec = data?.input?.secDb.find((x) => x.id?.guid === secGuid);
    const params = sec?.params;
    const is_circle = params?.type === 'cParams';

    const rebars = beam?.getConcrete()?.rebars || null;
    const standaloneBars = rebars?.standaloneBars ?? [];

    const ns = (lhs: number, rhs: number) => lhs - rhs;
    const sortedBars = standaloneBars.filter(x => x.startPoint != null).sort((lhs, rhs) => lhs.startPoint!.y !== rhs.startPoint!.y
        ? ns(lhs.startPoint!.y, rhs.startPoint!.y)
        : ns(lhs.startPoint!.z, rhs.startPoint!.z));
    const cornerDiameter = sortedBars.length > 1 ? sortedBars[0].diameter : 0;


    const distances = beam?.getConcrete()?.distances ?? null;
    const cover_mm =
        distances?.find((dist) => dist?.side === ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM)?.cover ?? 0.0;

    const rad = stirrupDiameter / 2; // the radius in meter
    const cen = cover_mm / 1000 + rad; // offset to the center of the stirrup

    // console.log(`cover: ${cen}, cover mm: ${cover_mm}`);
    // console.log(`stirrup_radius: ${stirrup_radius}, offset_stirrup: ${line_offset}`);

    const size = {
        hor: geom.hor.max - geom.hor.min,
        ver: geom.ver.max - geom.ver.min
    };

    if (is_circle) {
        drawer.drawPath(stirrup_style, new PathBuilder()
            .drawCircle([0, 0], size.hor / 2 - cen + rad)
            .drawCircle([0, 0], size.hor / 2 - cen - rad)
            , { title: "inner stirrup" }
        );
    }
    else {
        const cra = cornerDiameter / 2000;

        drawer.drawPath(stirrup_style, new PathBuilder()
            .drawRect(
                [geom.hor.min + cen - rad, geom.ver.min + cen - rad],
                size.hor - (cen - rad) * 2,
                size.ver - (cen - rad) * 2,
                {
                    radius: cra,
                })
            .drawRect(
                [geom.hor.min + cen + rad, geom.ver.min + cen + rad],
                size.hor - (cen + rad) * 2,
                size.ver - (cen + rad) * 2,
                {
                    radius: cra,
                },
            ));
    }
}